import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import key from "weak-key"
import { CheckBox, DropDownBox, List, ScrollView, SelectBox } from "devextreme-react"
import { useAppDispatch } from "redux/store"
import {
  comparatorSelector,
  setEstimateNumber,
  setEstimateRevisionNumber,
  setCompareByKeys,
} from "redux/comparator/iftComparatorSlice"
import {
  getAllEstimateRevisionsAction,
  getCompTotalDataAction,
  getCompratorDataAction,
} from "redux/comparator/middleware"

const IFTComparatorLevelHeader: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { projectIDs, estimateNumber, estimateRevisions, revisionNumbers, compareByKeys } =
    useSelector(comparatorSelector)
  const [quoteNos, setQuoteNos] = useState<Array<string>>([])
  const dropDownBoxRef: any = useRef(null)
  const COMPARE_BY = ["Cost Variance", "Carbon Variance"]

  const onSelectionChange = async ({ selectedItem }: any) => {
    await dispatch(setEstimateRevisionNumber([]))
    await dispatch(setEstimateNumber(selectedItem))
    setQuoteNos([])
    await dispatch(
      getAllEstimateRevisionsAction({ projectId: selectedItem?.PROJECT_ID?.toString() })
    )
  }

  const onCompareByOptionChange = ({ addedItems, removedItems }: any) => {
    if (addedItems && addedItems.length > 0) {
      dispatch(setCompareByKeys([...compareByKeys, ...addedItems]))
    }
    if (removedItems && removedItems.length > 0) {
      const remainingItems = compareByKeys.filter((item) => !removedItems.includes(item))
      dispatch(setCompareByKeys(remainingItems))
    }
  }

  const onValueChanged = async (e: any, revision: any) => {
    let revisionNum = []
    if (e.value === false) {
      revisionNum = revisionNumbers.filter((item) => item !== revision.Id)
      setQuoteNos(quoteNos.filter((qt) => qt !== revision?.QuoteNo))
    } else {
      revisionNum = [...revisionNumbers, revision?.Id]
      setQuoteNos([...quoteNos, revision?.QuoteNo])
    }
    dispatch(setEstimateRevisionNumber(revisionNum))

    const data = { estimateNumber, revisionNumbers: revisionNum }
    await dispatch(getCompratorDataAction(data))
    await dispatch(getCompTotalDataAction(data))
  }

  const renderDropdown = () => {
    return (
      <ScrollView>
        <div>
          {estimateRevisions.map((rev) => (
            <div key={key(rev)} className="m-4">
              <CheckBox
                text={rev.QuoteNo}
                hint={rev.QuoteNo}
                onValueChanged={(e) => onValueChanged(e, rev)}
                disabled={revisionNumbers.length === 3 && !revisionNumbers.includes(rev.Id)}
              />
            </div>
          ))}
        </div>
      </ScrollView>
    )
  }

  return (
    <div className="estimateLevelHeader dx-card">
      <div className="dropdown">
        <label>{t("iftComparatorMain.baseEstimate")}</label>
        <SelectBox
          dataSource={projectIDs}
          displayExpr="PROJECT_QUOTE_NO"
          valueExpr="PROJECT_ID"
          value={estimateNumber}
          searchEnabled
          onSelectionChanged={onSelectionChange}
        />
      </div>
      <div className="dropdown">
        <label>{t("iftComparatorMain.revisions")}</label>
        <DropDownBox
          placeholder="Select Revisions"
          label={quoteNos.toString()}
          ref={dropDownBoxRef}
          dataSource={estimateRevisions}
          dropDownOptions={{ showCloseButton: true, maxHeight: 200, enableBodyScroll: true }}
          contentRender={renderDropdown}
          labelMode="floating"
        />
      </div>
      <div className="dropdown">
        <label>Compare By</label>
        <DropDownBox
          placeholder="Compare By"
          label={compareByKeys.toString()}
          value={compareByKeys}
          ref={dropDownBoxRef}
          dataSource={COMPARE_BY}
          dropDownOptions={{ showCloseButton: true, maxHeight: 200, enableBodyScroll: true }}
          labelMode="floating"
        >
          <List
            dataSource={COMPARE_BY}
            selectedItemKeys={compareByKeys}
            selectionMode="multiple"
            onSelectionChanged={onCompareByOptionChange}
            showSelectionControls
          />
        </DropDownBox>
      </div>
    </div>
  )
}

export default IFTComparatorLevelHeader
